//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { mapState,mapActions } from 'vuex';

export default{
    data(){
        return {
            list:[
                {
                    label:'首页',
                    val:'/homepage'
                },
                {
                    label:'列表',
                    val:'/list'
                },
                {
                    label:'图片',
                    val:'/picture'
                },
                {
                    label:'更多',
                    val:'/more'
                },
            ]
        }
    },
    mounted(){
        console.log(location.hash);
    },
    computed:{
        ...mapState([
            'activeTab'
        ]),

    },
    methods:{
        ...mapActions([
            'test'
        ]),
        navigate(label,url){
            this.test(label)
            this.$router.push(url)
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/components/nav.vue